import { render, staticRenderFns } from "./dotCash.vue?vue&type=template&id=010c1e47&scoped=true&"
import script from "./dotCash.vue?vue&type=script&lang=js&"
export * from "./dotCash.vue?vue&type=script&lang=js&"
import style0 from "./dotCash.vue?vue&type=style&index=0&id=010c1e47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010c1e47",
  null
  
)

export default component.exports